import {Constructor} from "../../global/constructor";
import TrackedModel from "~/models/tracked/trackedModel";
import ElementHandler from "~/services/elementHandler";

export default function SortableMixin<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    sort_order: number

    // these should be already defined in the other places
    // TODO: specify Constructor better so I don't have to redefine these things
    sortableParent: TrackedModel
    sortableHandler: ElementHandler
    rootName: string

    get isLast(): boolean {
      const nextSortOrder = this.sortableParent.nextSortOrderFor(this.rootName)
      return nextSortOrder !== null && this.sort_order === nextSortOrder - 1;
    }

    get isFirst(): boolean {
      return this.sort_order <= 0;
    }

    moveUp(): void {
      if (!this.isFirst) {
        this.sort_order--;
        this.sortableHandler.updateElementPositions(this.sortableParent, this, this.sort_order);
      }
    }

    moveDown(): void {
      if (!this.isLast) {
        this.sort_order++;
        this.sortableHandler.updateElementPositions(this.sortableParent, this, this.sort_order);
      }
    }
  };
}